import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = { class: "font-weight-bold text-truncate" }
const _hoisted_4 = { class: "size" }
const _hoisted_5 = {
  key: 1,
  class: "text-truncate opacity"
}

import {computed} from 'vue';
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import CabinetUploadHelper from "~/cabinet/ts/service/CabinetUploadHelper";


const __default__ = {
    name: "OnlineMessageFileContentDescription"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    attachment: {},
    icon: {}
  },
  emits: ["icon-click"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit

let fileSize = computed(() => {
    if (props.attachment.fileSize > 0) {
        return CabinetUploadHelper.sizeToString(Math.ceil(props.attachment.fileSize / 1000));
    } else {
        return null;
    }
});

return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "attachment-icon",
        onClickCapture: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(emits)('icon-click')), ["stop","prevent"]))
      }, [
        _createVNode(FontAwesomeIcon, {
          bold: "",
          icon: __props.icon ? __props.icon : __props.attachment.type.icon
        }, null, 8, ["icon"])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(__props.attachment.fileName) + " ", 1),
        _renderSlot(_ctx.$slots, "after-name")
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.$slots.size)
          ? _renderSlot(_ctx.$slots, "size", { key: 0 })
          : (__props.attachment.type.id === 'link')
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(__props.attachment.url), 1)
              ])), [
                [_directive_my_tooltip, __props.attachment.url]
              ])
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(_unref(fileSize)), 1)
              ], 64))
      ])
    ])
  ]))
}
}

})